export default function FooterShim() {
  return(
    <div className="footer-shim"></div>
  )
}